export default {
  insertParam: function (url, param, value) {
    url +=
      (url.split('?')[1] ? '&' : '?') + param + '=' + encodeURIComponent(value);
    return url;
  },
};
